<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>
    <div class="card-block">
      <div class="row">
        <div class="col-sm-12">
          <div class="small mb-1">
            Changer les dates, supprimera les filtres (car ils sont générés à
            partir des dates)
          </div>
        </div>
        <div class="form-group col-sm-3">
          <label>Date du formulaire entre</label>
          <datepicker
            v-model="formFilters.begin"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
        <div class="form-group col-sm-3">
          <label>et</label>
          <datepicker
            v-model="formFilters.end"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
        <div class="form-group col-sm-3">
          <label>Commercial</label>
          <multiselect
            placeholder="Choisir un ou des commerciaux"
            v-model="formFilters.commercial"
            :options="commercials"
            label="label"
            track-by="label"
            class="custom-multiselect"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-3">
          <label>Type de clients</label>
          <el-checkbox-group v-model="formFilters.clientType">
            <el-checkbox label="B2C">B2C</el-checkbox>
            <el-checkbox label="B2B">B2B</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="form-group col-sm-4">
          <button
            type="button"
            class="btn btn-sm btn-secondary"
            @click="updateFormFilters"
          >
            <i class="icon-eye"></i>&nbsp; Visualiser
          </button>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-sm-12">
          <div class="small mb-1">
            Appliquez les filtres pour voir les résultats ({{ countClient }}
            formulaires)
          </div>

          <label class="h5 mb-1">Filtres</label>
        </div>
        <div class="form-group col-sm-4">
          <label>UTM Sources</label>
          <multiselect
            deselectLabel="X"
            selectLabel="Ajouter"
            v-model="filters.sources"
            :options="values.utm_sources"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect custom-no-wrap"
            group-values="values"
            group-label="type"
            :group-select="true"
            selectGroupLabel=""
            deselectGroupLabel=""
            @input="apply()"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-4">
          <label>UTM Campaigns</label>
          <multiselect
            deselectLabel="X"
            selectLabel="Ajouter"
            v-model="filters.campaigns"
            :options="values.utm_campaigns"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect custom-no-wrap"
            group-values="values"
            group-label="type"
            :group-select="true"
            selectGroupLabel=""
            deselectGroupLabel=""
            @input="apply()"
          >
          </multiselect>
        </div>

        <div class="form-group col-sm-4">
          <label>UTM Mediums</label>
          <multiselect
            deselectLabel="X"
            selectLabel="Ajouter"
            v-model="filters.mediums"
            :options="values.utm_mediums"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect custom-no-wrap"
            group-values="values"
            group-label="type"
            :group-select="true"
            selectGroupLabel=""
            deselectGroupLabel=""
            @input="apply()"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-4">
          <label>UTM Terms</label>
          <multiselect
            deselectLabel="X"
            selectLabel="Ajouter"
            v-model="filters.terms"
            :options="values.utm_terms"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect custom-no-wrap"
            group-values="values"
            group-label="type"
            :group-select="true"
            selectGroupLabel=""
            deselectGroupLabel=""
            @input="apply()"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-4">
          <label>UTM Contents</label>
          <multiselect
            deselectLabel="X"
            selectLabel="Ajouter"
            v-model="filters.contents"
            :options="values.utm_contents"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect custom-no-wrap"
            group-values="values"
            group-label="type"
            :group-select="true"
            selectGroupLabel=""
            deselectGroupLabel=""
            @input="apply()"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-4">
          <label>Landing pages (source)</label>
          <multiselect
            deselectLabel="X"
            selectLabel="Ajouter"
            v-model="filters.sourceUrls"
            :options="values.sourceUrls"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect custom-no-wrap"
            group-values="values"
            group-label="type"
            :group-select="true"
            selectGroupLabel=""
            deselectGroupLabel=""
            @input="apply()"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-4">
          <label>Referer pages (origine)</label>
          <multiselect
            deselectLabel="X"
            selectLabel="Ajouter"
            v-model="filters.referers"
            :options="values.referers"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect custom-no-wrap"
            group-values="values"
            group-label="type"
            :group-select="true"
            selectGroupLabel=""
            deselectGroupLabel=""
            @input="apply()"
          >
          </multiselect>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Multiselect,
    Datepicker,
  },

  props: {
    default: {
      type: Object,
      required: true,
    },
    values: {
      type: Object,
      required: true,
    },
    countClient: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      formFilters: {
        begin: moment().startOf("M").format(),
        end: moment().endOf("M").format(),
        commercial: null,
        clientType: [],
      },
      dates: {},
      filters: {},
      allOptions: {
        source: false,
        campaigns: false,
      },
      commercials: [],
    };
  },

  async created() {
    this.filters = this.default;
    this.dates = this.defaultDates;

    await this.fetchCommercials();
  },

  methods: {
    updateFormFilters() {
      this.$emit("formFilters", this.formFilters);

      this.filters = {};
    },

    apply() {
      this.$emit("updateFilter", this.filters);
    },

    async fetchCommercials() {
      const { data } = await this.$api.get("/users/commercials/search");

      this.commercials = data.map((c) => ({
        value: c.email,
        label: c.commercial.pseudo,
      }));
    },
  },
};
</script>

<style lang="scss">
.custom-multiselect {
  &.custom-no-wrap {
    .multiselect__tags {
      max-height: 68px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .multiselect__tag {
      white-space: normal;
    }
  }
}
</style>
